import React from "react"
import { ReportFormDrawer } from "Pages/ReportsAlerts/Reports/@components"
import { Grid } from "@mui/material"
import { ReportNameSection } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import {
	ReportFormDrawerExportFiltersSection,
	ReportFormDrawerFrequencySection,
	ReportFormDrawerSearchConfigSection,
	ReportFormDrawerSitesOfficesSection
} from "Pages/ReportsAlerts/Reports/Extra/Page/Drawer/Sections"

export default function ReportExtraFormDrawer() {

	return <ReportFormDrawer>
		<Grid item xs={4} data-tour-id="tour-report-name">
			<ReportNameSection/>
		</Grid>
		<Grid item xs={12}>
			<ReportFormDrawerSitesOfficesSection/>
		</Grid>
		<Grid item xs={12}>
			<ReportFormDrawerSearchConfigSection/>
		</Grid>
		<Grid item xs={12}>
			<ReportFormDrawerExportFiltersSection/>
		</Grid>
		<Grid item xs={12}>
			<ReportFormDrawerFrequencySection/>
		</Grid>
	</ReportFormDrawer>
}